import axios from 'axios';
import sha1 from 'sha1'
import qs from 'qs'
import router from "../router/index"
import {
    ElMessage
} from 'element-plus';
import { Base64 } from 'js-base64';


// const BASEURL = process.env.NODE_ENV === "production" ? 'http://java-api.suntaeiv.com:8080/operation_dispatch_center' : '/api';
const BASEURL = process.env.NODE_ENV === "production" ? 'http://47.105.39.99:8080/operation_dispatch_center' : '/api';

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了

    // timeout: 500000,
    // baseURL: "http://192.168.8.152:4579/operation_dispatch_center",
    baseURL: BASEURL,
});

service.interceptors.request.use(
    config => {
        if (config.url === '/api/login/get_verify_code') {
            return config
        }
        let token = localStorage.getItem('op_token') || '';
        let sk = localStorage.getItem('op_sk') || '';
        let username = localStorage.getItem('account') || '';
        // 1. 获取请求参数 row
        // let data = config.data;
        //  let row = data.row;
        let data = config.data || (config['data'] = []);
        config.responseType = data.responseType
        data = data.data || (data['data'] = {});
        let sign_list = [];
        // 3. 将row参数进行升序排序
        // const newkey = Object.keys(data).sort();
        // // 4. 将排序后的参数进行拼接
        // 
        // for (let i = 0; i < newkey.length; i++) {
        //     newObj[newkey[i]] = data[newkey[i]];
        // }
        // 4. 将键和值进行 URLcode 编码 ,= 不需要编码
        for (let item in data) {
            let _key = item;
            let _val = data[item];
            // sign_list.push(encodeURIComponent(_key) + "=" + encodeURIComponent(_val));
            data[_key] = sign_list[_key] = Base64.encode(_val);
        }
        let time_stamp = '' + Date.parse(String(new Date())) / 1000
        // let row:any = data.row || (config['data']['row'] = []);
        // 2. 将 row 中植入 token 和 time_stamp 当前时间戳(秒)
        sign_list['token'] = Base64.encode(token);
        sign_list['time_stamp'] = Base64.encode(time_stamp);
        sign_list['account'] = Base64.encode(username);
        // row['username'] = username;

        const newkey = Object.keys(sign_list).sort();
        const newObj = {};
        for (let i = 0; i < newkey.length; i++) {
            newObj[newkey[i]] = sign_list[newkey[i]];
        }
        for (let item in newObj) {
            let key = item;
            let val = newObj[item];
            // sign_list.push(encodeURIComponent(_key) + "=" + encodeURIComponent(_val));
            sign_list.push(key + "=" + val);
        }
        // 5. 将将键值对重新组
        let sign_str = sign_list.join('&');
        // 6. 使用秘钥将其前后拼接 生成待签名字符串
        sign_str = sk + sign_str + sk;
        // 7. 使用 sha1 的加密算法将其签名
        sign_str = sha1(sign_str);
        // 8. 将签名的字符串放到与 row 同级参数上 sign 
        // data['sign'] = sign_str;
        let sign = sign_str;
        if (config && config.headers) { // 多一步判断
            config.headers['token'] = token
            config.headers['time_stamp'] = time_stamp
            config.headers['account'] = username
            config.headers['sign'] = sign
        }
        config.data = qs.stringify(data)
        return config
    },
    error => {

        return error;
    }
);
let isReFreshPadding = true;
service.interceptors.response.use(
    response => {
        let res = response.data
        if (isReFreshPadding) {
            if (response.data.code === -9998 || response.data.code === -9999) {
                isReFreshPadding = false
                router.push({
                    path: "/login"
                })
                ElMessage.error(res["message"])
            }
        }
        if (response.data.code === -1) {
            isReFreshPadding = true
            ElMessage.error(res["message"])
            if (res["message"] == "密码有误") {
                return res
            }
            if (res["message"] == "验证码有误") {
                return res
            }
        }
        if (response.data.code === -9997) {
            if (isReFreshPadding) {
                isReFreshPadding = false
                ElMessage.error(res["message"])
            }
        }
        if (response.data.code === 0) {
            isReFreshPadding = true
            return res
        }
        if (response.data.code === -3) {
            isReFreshPadding = true
            return res
        }
        if (response.data.code == undefined) {
            isReFreshPadding = true
            return res
        }
    },
    error => {
        return error;
    }
);

export default service;